import { connect } from 'react-redux';
// import { RootDispatch } from '../../types'
import { getToasts } from '../../modules/toast/selectors';
import { hideToast } from '../../modules/toast/actions';
import ToastProvider from './ToastProvider';
const mapState = (state) => ({
    toasts: getToasts(state)
});
const mapDispatch = (dispatch) => ({
    onClose: (id) => dispatch(hideToast(id))
});
export default connect(mapState, mapDispatch)(ToastProvider);
//# sourceMappingURL=ToastProvider.container.js.map